export const DICTIONARY = {
  title: {
    sv: "Google Workspace for Education",
  },
  abstract:{
    sv: "Det här är en konfigurationsguide för att ansluta Google Workspace for Education direkt till Skolfederation.",
  },
  introduction:{
    sv: "<p>För att logga in med Google Workspace for Education måste den tjänst som skolan önskar möjliggöra inloggning\
    till (SP) och Google Workspace for Education konfigureras med varandras SAML-metadata. Guiden beskriver hur man hämtar\
    metadata från Google Workspace for Education, kompletterar metadatat med ytterligare information för att sedan laddar\
    upp det till Skolfederation. SP hämtar i sin tur metadatat från Skolfederation. Guiden beskriver\
    också hur man konfigurerar Google Workspace for Education med metadata från SP. När allt är klart ska det gå att använda\
    sin Google Workspace for Education domän för inloggning mot inlagda tjänster (SP).</p>\
    \
    <p>Exemplet i denna guide är en testtjänst som Skolverket tillhandahåller för digitala nationella\
    prov. Tjänsten och dess utförande kan ändras av Skolverket i och med deras försöksverksamhet. Vänd\
    er till Skolverket för frågor om aktuella uppgifter.</p>\
    \
    <p>I första stegen av guiden konfigureras attributet eduPersonPrincipalName (ePPN) i Google Workspace for Education, detta då\
    det senare används vid inloggningstillfället mot Skolverkets testtjänst. Har ni redan ePPN, eller\
    ska ni konfigurera mot en tjänst som inte kräver ePPN, kan ni bortse från detta steg.</p>\
    \
    <p>Denna guide är tänkt som stöd för huvudmän i konfigurationen. Har ni samarbetspartners eller\
    konsulter för Google Workspace for Education, kontakta dessa för detaljerad hjälp i hur ni kan konfigurera tjänster i\
    er Google Workspace for Education-miljö.</p>"
  },
  md_title:{
    sv: "Metadataverktyg för Google IdP"
  },
  md_intro:{
    sv: "<p>Använd verktyget för att komplettera metadata för Google Workspace for Education så att det fungerar i Skolfederation.</p>\n" +
        "<ol>\n" +
          "<li>Ladda upp metadata från din Google Workspace for Education-IdP.</li>\n" +
          "<li>Fyll i nödvändig information om din organisation.</li>\n" +
          "<li>Klicka på \"Ladda ner\" för att spara metadata lokalt.</li>\n" +
          "<li>Klicka på \"Publicera\" för att komma till Skolfederations guide över hur man publicerar metadata.</li>\n" +
        "</ol>\n" +
        "<p>Besök Skolfederations <a href=\"https://wiki.federationer.internetstiftelsen.se/x/EQDFAg\" target=\"_blank\">Wiki</a> för att få mer information om hur du konfigurerar din Google IdP.</p>\n" +
        "<p>Läs mer om Skolfederation: <a href=\"https://www.skolfederation.se\" target=\"_blank\">https://www.skolfederation.se</a></p>\n" +
        "<h4>Notera</h4>\n" +
        "<ul>\n" +
        "<li>Du måste fylla i all information i metadataverktyget. Om du inte fyller i all information kommer ditt metadata inte att godkännas av Skolfederation.</li>\n" +
        "<li>Du måste publicera ditt metadata för att det ska börja fungera i Skolfederation. När du har publicerat ditt metadata kommer det att finnas tillgängligt för andra medlemmar i Skolfederation.</li>"+
        "</ul>\n" +
        "<p>För mer information, vänligen kontakta oss på <a href=\"mailto:info@skolfederation.se\">info@skolfederation.se</a>.</p>"
  },
  input_title:{
    sv: "Komplettering"
  },
  input_introduction: {
    sv: "Metadatat måste kompletteras med information innan det publiceras i Skolfederation."
  },
  organizationname_sv_desc: {
    sv: "Ange organisationens namn med svenskt språk som representeras av IdP:n."
  },
  organizationdisplayname_sv_desc: {
    sv: "Namn med svenskt språk som visas för användarna när de ska välja vilken organisation de ska logga in med."
  },
  organizationurl_sv_desc: {
    sv: "URL till organisationens webbsida. Om ni har stöd för flera språk ange den svenska här, annars huvudsidan."
  },
  organizationname_en_desc: {
    sv: "Ange organisationens namn med engelskt språk som representeras av IdP:n."
  },
  organizationdisplayname_en_desc: {
    sv: "Namn med engelskt språk som visas för användarna när de ska välja vilken organisation de ska logga in med"
  },
  organizationurl_en_desc: {
    sv: "URL till organisationens webbsida. Om ni har stöd för flera språk ange den engelska här, annars huvudsidan."
  },
  scope_desc: {
    sv: "Användarnamnet, attributet eduPersonPrincipalName (EPPN), består att ett prefix och ett suffix separerat med ett @. Suffixet är det som ska anges här. Suffixet MÅSTE vara ett registrerat domännamn. Användarnamnet ska inte förväxlas med användarens E-postadress. En E-postadress återanvänds gärna då ny elever börjar skolan med samma namn som tidigare avgångselev. Användarnamnet måste vara unikt även efter att användaren har avslutat sin skolgång, det får inte återanvändas"
  }
};
